import React from "react";
import { IconButton, Tooltip } from "@mui/material";
import { EsgEditIcon } from "assets";
import { COLORS } from "components/consts";

interface EditButtonProps {
    onClick: () => void;
    tooltipTitle?: string;
    size?: "small" | "medium" | "large";
    disabled?: boolean;
    "aria-label"?: string;
}

export const EditButton = ({
    onClick,
    tooltipTitle = "Edit",
    size = "small",
    disabled = false,
    "aria-label": ariaLabel = "Edit"
}: EditButtonProps) => (
    <Tooltip arrow placement="top" title={tooltipTitle}>
        <IconButton
            aria-label={ariaLabel}
            size={size}
            sx={{
                maxHeight: "28px",
                maxWidth: "28px",
                color: COLORS.Romance,
                "&:hover": {
                    backgroundColor: "rgba(0, 0, 0, 0.04)",
                },
                "&:active": {
                    backgroundColor: "rgba(0, 0, 0, 0.12)",
                },
                "&:disabled": {
                    color: "rgba(0, 0, 0, 0.26)",
                }
            }}
            onClick={onClick}
            disabled={disabled}
        >
            <EsgEditIcon color={COLORS.Romance} />
        </IconButton>
    </Tooltip>
);